import React from 'react'
import { CategoryDeleteApi, CategoryCreateApi, CategoryUpdateApi, CategoryGetApi, MasterListApi, MasterCreateApi, MasterDeleteApi, MasterGetApi, MasterUpdateApi } from '../../../../services/api'
import { deleteDataFromApi, getDataFromApi, GetTenantDetails, postDataFromApi, putDataFromApi } from '../../../../services/commonServices';
import { toast } from 'react-toastify';

export const handleLabParamCreateAndUpdate = async (
    formData,
    handleSubmit,
    setFormData,
    setIsOverlayLoader,
    navigate,
    useFor
) => {
    try {
        setIsOverlayLoader(true)
        let isValidate = handleSubmit();
        if (!isValidate) {
            return false;
        }
        const payload = {

            "model_name": "lab_commodity_spec",
            "data": {
                "fk_commodityid": formData[0]?.fk_commodityid,
                "fk_sub_commodityid": formData[0]?.fk_sub_commodityid,
                "tenant": GetTenantDetails(1),
                "fk_labid": formData[0]?.fk_labid,
            }

        };
        let res;
        let lab_payload = {
            "model_name": "lab_parameters",
            "data": {
                ...payload.data,
                "lp_lcl": formData[0]?.lp_lcl,
                "lp_ucl": formData[0]?.lp_ucl,
                "lp_outofscope": formData[0]?.lp_outofscope,
                "basis": formData[0]?.fk_basisid,
                "fk_parameterid": formData[0]?.fk_parameterid,
                "fk_standardid": formData[0]?.fk_standardid,
                "fk_groupid": formData[0]?.fk_groupid,
                "is_ops_usr_created": useFor === "approve"
            },
            "tenant": 1
        }
        if (formData[0].lp_id) {
            lab_payload = {
                ...lab_payload,
                id: formData[0].lp_id
            }
            let updateCategory = MasterUpdateApi('lab_parameters', 'lp_id', formData[0].lp_id)
            res = await putDataFromApi(updateCategory, lab_payload)

        } else {
            let lcp_id = '';
            res = await postDataFromApi(MasterCreateApi, payload);
            if (res.data.data === 400) {
                lcp_id = res?.data?.data?.existing_lcp_id?.[0]
            }
            else if (res.data.data === 200) {
                lcp_id = res?.data?.data?.lcp_id
            }
            lab_payload = {
                ...lab_payload,
                data: {
                    ...lab_payload.data,
                    "lcp_id": lcp_id,
                }
            }
            res = await postDataFromApi(MasterCreateApi, lab_payload)
        }

        if (res?.data?.status === 200) {

            toast.success(res?.data?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            navigate("/operation/parameters")
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }

    } catch (error) {
        console.log('errrr', error)
    }
    finally {
        setIsOverlayLoader(false)
    }
}

export const handleGetLabParam = async (
    lp_id,
    setFormData,
    setIsOverlayLoader
) => {
    try {
        setIsOverlayLoader(true);

        const getDataApi = MasterGetApi('lab_parameters', 'lp_id', lp_id)
        const res = await postDataFromApi(getDataApi,
            {
                "model_name": "lab_parameters",
                id: parseInt(lp_id)
            });

        if (res?.data?.status === 200) {
            const resData = res.data.data || {};

            setFormData((prevData) => ({
                ...prevData,
                0: {
                    ...prevData[0],
                    ...resData,
                    ['fk_basisid']: res.data.data.param_basis.map((base) => base.fk_basisid)
                },
            }));
        } else {
            toast.error(res?.message || "Failed to fetch category", {
                position: "top-right",
                autoClose: 2000,
                theme: "light",
            });
        }
    } catch (error) {
        console.error("Error fetching category:", error);
    } finally {
        setIsOverlayLoader(false);
    }
};




export const handleLabParamDelete = async (
    lp_id,
    setIsDelete,
    getAllListingData,
    setPopupIndex

) => {
    try {
        let deleteapi = MasterDeleteApi('lab_parameters', 'lp_id', lp_id)
        let res = await deleteDataFromApi(deleteapi);
        if (res?.data?.status === 200) {
            toast.success(res.data.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            getAllListingData();
        } else {
            toast.error(res.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    catch (ex) { }
    finally {
        setIsDelete(false);
        setPopupIndex(-1);
    }


}